import { useMemo } from "react";

import { Redirect, useHistory } from "react-router";

import { Button, Icon, Text } from "@alpacahq/ui/old";

import { Path } from "~/v2/path";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { FAQ } from "../../../../../components/common/FAQ";
import { BankLinkageAlert } from "../../common/BankLinkageAlert";
import { Layout } from "../../common/Layout";
import { WIRE_FAQ } from "../../link/wire";
import { IncomingWireInstructions } from "./IncomingWireInstructions";
import { InternationalWireNotes } from "./InternationalWireNotes";

const WireDepositPage = () => {
  const history = useHistory();
  const { currentAccount } = useAccountContext({ liveOnly: true });

  const onBackClicked = () => {
    history.push(Path.ROUTE_FUNDING_DEPOSIT);
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: window.location.search is not reactive, so this dep can never fire; it documents that the value is read from the URL at mount. Reading useLocation() instead would make it reactive and is left for a follow-up.
  const isInternational = useMemo(() => {
    const search = new URLSearchParams(window.location.search);
    return search.get("international") === "true";
  }, [window?.location?.search]);

  const isBankLinkageDisallowed =
    currentAccount?.capabilities?.bank_linkable_status === "disallowed";

  // IRA accounts cannot deposit via wire
  const isIRA = currentAccount?.account_type === "ira";
  if (isIRA) {
    return <Redirect to={Path.ROUTE_FUNDING_DEPOSIT} />;
  }

  return (
    <Layout
      title="Wire Transfer"
      subtitle="Instructions for depositing funds via wire transfer."
      faq={<FAQ faq={WIRE_FAQ} />}
    >
      <Button onClick={onBackClicked} variant="secondary" className="mb-8">
        <Icon name="ArrowLeftCircle" className="mr-2" />
        Back
      </Button>

      <Text className="pb-4 font-semibold text-xl">Wire Instructions</Text>

      {isBankLinkageDisallowed ? (
        <BankLinkageAlert />
      ) : (
        <>
          {isInternational && <InternationalWireNotes className="mb-4" />}

          <div className="w-full max-w-lg rounded border border-gray-200 p-4">
            <IncomingWireInstructions
              accountNumber={currentAccount?.account_number ?? ""}
            />
          </div>
        </>
      )}
    </Layout>
  );
};

export default WireDepositPage;
